module.exports = __webpack_public_path__ + "static/media/desktopScreenshot02.63347082.jpg";